// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 601 ? "component---src-pages-index-mdx" : chunkId) + "-" + {"454":"e00c615190489b7317be","601":"c6e88c20c2731a2feabc"}[chunkId] + ".js";
};